import { render, staticRenderFns } from "./leaderboard-action-score-card.vue?vue&type=template&id=090a1218&scoped=true&"
import script from "./leaderboard-action-score-card.vue?vue&type=script&lang=js&"
export * from "./leaderboard-action-score-card.vue?vue&type=script&lang=js&"
import style0 from "./leaderboard-action-score-card.vue?vue&type=style&index=0&id=090a1218&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090a1218",
  null
  
)

export default component.exports